import { render, staticRenderFns } from "./StickerSvg.vue?vue&type=template&id=78ee10d8&"
import script from "./StickerSvg.vue?vue&type=script&lang=js&"
export * from "./StickerSvg.vue?vue&type=script&lang=js&"
import style0 from "./StickerSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports